import { ICreateTransferPin, IHookForm } from "../../interfaces-and-types";
import { SubmitButton, TextInput } from "../../hook-form";
import {
  FormContainer,
  ModalContainer,
  PinCodeInputModal,
  PinPromptWithDisplay,
  SectionHeader,
} from "../../components";

interface ICreateTransferPinViewProps extends IHookForm<ICreateTransferPin> {
  isModalOpen: boolean;
  closeModal: () => void;

  formValues: ICreateTransferPin;

  isOpenCreatePinInput: boolean;
  onOpenCreatePinInput: () => void;
  onCloseCreatePinInput: () => void;
  combinedCreatePinInputErrors: string | null;
  onCreatePinSubmit: (pin: string) => boolean;
  onCreatePinCorrect: (/*pin: string*/) => boolean;

  isOpenConfirmPinInput: boolean;
  onOpenConfirmPinInput: () => void;
  onCloseConfirmPinInput: () => void;
  combinedConfirmPinInputErrors: string | null;
  onConfirmPinSubmit: (confirmPin: string) => boolean;
  onConfirmPinCorrect: (/*pin: string*/) => boolean;
}

export const View = ({
  isModalOpen,
  closeModal,

  formValues,

  isOpenCreatePinInput,
  onOpenCreatePinInput,
  onCloseCreatePinInput,
  combinedCreatePinInputErrors,
  onCreatePinSubmit,
  onCreatePinCorrect,

  isOpenConfirmPinInput,
  onOpenConfirmPinInput,
  onCloseConfirmPinInput,
  combinedConfirmPinInputErrors,
  onConfirmPinSubmit,
  onConfirmPinCorrect,

  errors,
  handleSubmit,
  register,
  control,
}: ICreateTransferPinViewProps) => {
  return (
    <>
      <ModalContainer
        isModalOpen={isModalOpen}
        closeModal={closeModal}
        modalHeader={
          <SectionHeader
            title="Create Transfer PIN"
            subtitle="Create a PIN that you can use to initiate transfers from your account."
          />
        }
      >
        <form onSubmit={handleSubmit}>
          <div className="flex-container col justify-content--center align-items--center">
            <div style={{ minWidth: "50%", maxWidth: 800 }}>
              <div className="flex-box">
                <TextInput
                  name="password"
                  label="Password"
                  type="password"
                  register={register}
                  errors={errors}
                />
              </div>

              <div className="flex-container col mt-5">
                <div className="flex-container mb-3">
                  <div className="flex-box">New PIN</div>
                </div>

                <div onClick={onOpenCreatePinInput}>
                  <PinPromptWithDisplay
                    pin={formValues.pin}
                    placeHolder={"Enter New PIN"}
                  />

                  <span className="switchapp-small text-danger font-ctm--semibold fontSize-12">
                    {combinedCreatePinInputErrors}
                  </span>
                </div>
              </div>

              <div className="flex-container col mt-5">
                <span>Confirm New PIN</span>

                <div onClick={onOpenConfirmPinInput}>
                  <PinPromptWithDisplay
                    pin={formValues.confirm_pin}
                    placeHolder={"Confirm New PIN"}
                  />

                  <span className="switchapp-small text-danger font-ctm--semibold fontSize-12">
                    {combinedConfirmPinInputErrors}
                  </span>
                </div>
              </div>

              <div className="flex-container mt-5">
                <SubmitButton className="mt-5 align-self--stretch">
                  Save PIN
                </SubmitButton>
              </div>
            </div>
          </div>
        </form>
      </ModalContainer>

      <PinCodeInputModal
        title="Create Transfer PIN"
        subtitle="Enter 4-digit code for transfers"
        // buttonText="Submit PIN"
        errorMessage={combinedCreatePinInputErrors} // get from useApiErrors()
        showPinValues={false}
        isModalOpen={isOpenCreatePinInput}
        pin={formValues.pin}
        pinCodeLength={4}
        closeModal={onCloseCreatePinInput}
        onChange={onCreatePinSubmit}
        handlePinSubmit={onCreatePinCorrect}
      />

      <PinCodeInputModal
        title="Confirm Transfer PIN"
        subtitle="Enter same digits again to confirm..."
        // buttonText="Submit PIN"
        errorMessage={combinedConfirmPinInputErrors} // get from useApiErrors()
        showPinValues={false}
        isModalOpen={isOpenConfirmPinInput}
        pin={formValues.confirm_pin}
        pinCodeLength={4}
        closeModal={onCloseConfirmPinInput}
        onChange={onConfirmPinSubmit}
        handlePinSubmit={onConfirmPinCorrect}
      />
    </>
  );
};
